module.exports = __webpack_public_path__ + "apple-icon-114x114.png?34558b53a1a64da472a5c491398054ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-114x114.png
// module id = 127
// module chunks = 0